    <div class="row">
        <div class="col-12">
            <div class="row">
                <div *ngFor="let panel of Paneles" class="col-sm-3">
                    <div class="card mini-stats-wid">
                      <div class="card-body">
                        <div class="media">
                          <div class="media-body">
                            <p class="text-muted fw-medium">{{panel.TITULO}}</p>
                            <h4 class="mb-0">{{panel.VALOR}}</h4>
                          </div>

                          <div class="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                            <span class="avatar-title">
                              <i class="bx {{panel.ICONO}} font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- end card-body -->
                    </div>                    
                </div>
            </div>
            <!-- end row -->
        </div>
    </div>